/**
 * Created by shubham on 7/6/18.
 */

import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { socDetailsComponent } from '../socIdDetails/socIdDetails.component';
import { TranslateModule } from 'ng2-translate';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [
        socDetailsComponent
    ],
    exports: [
        socDetailsComponent,
    ]
})

export class SOCDetailsModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/socIdDetails/socIdDetails.module.ts